import * as React from 'react';

import {
  VerticalPromoBlocks,
} from '../../components/vertical_promo_blocks/vertical_promo_blocks';
import { IMainPage } from '../../models/mainpage';
import { IPromo } from '../../models/promo';
import { ISeoBlockItem } from '../../models/seo_urls';
import { IRegionsData } from '../../models/regions_data';

import { connect } from 'react-redux';

interface IProps {
  promo: IPromo[];
  seoUrlsBlocks: ISeoBlockItem[];
  regionsData: IRegionsData;
  section: string;
  isFetching: boolean;
  mainpage: IMainPage;
}

class VerticalPromo extends React.Component<IProps> {
  public render() {
    const substitutedPromoIndex = this.props.promo.findIndex(promo =>
      promo.id === 'newBuildingsPromos',
    );

    const newProps = Object.assign({}, this.props);

    if (substitutedPromoIndex !== -1) {
      newProps.promo[substitutedPromoIndex] = {
        extraLinks: [],
        id: 'newBuildingSalesLeaders',
        links: [{
          h1: 'Лидеры продаж',
          objectCount: 0,
          description: 'За прошлый квартал',
          title: 'Лидеры продаж',
          url: '/stati-rejting-zhilyh-kompleksov-po-tempam-prodazh-po-itogam-4-kvartaly-2018-goda-289242/',
        }],
        title: 'Лидеры продаж',
        type: 'iconic',
      };
    }

    return (
      <VerticalPromoBlocks
        promoBlocks={newProps.promo}
        promoMenu={newProps.seoUrlsBlocks}
        regionsData={newProps.regionsData}
        section={newProps.section}
        />
    );
  }
}

function parsePromoBlocks(promos: IPromo[]) {
  const pikPromo = promos.find(block => block.id === 'newBuildingsBooking');

  if (pikPromo) {
    return promos.filter((promo) => {
      return promo.id !== 'newBuildingsBooking';
    });
  }

  return promos;
}

const VerticalPromoWrapper = connect((state: { mainpage: IMainPage }) => ({
  mainpage: state.mainpage,
  promo: state.mainpage.section === 'new-buildings'
    ? parsePromoBlocks(
        state.mainpage.promoBlocks
      )
    : state.mainpage.promoBlocks,
  seoUrlsBlocks: state.mainpage.seoUrlsBlocks,
  isFetching: state.mainpage.isFetching,
  regionsData: state.mainpage.regionsData,
  section: state.mainpage.section,
}))(VerticalPromo);

export {
  VerticalPromoWrapper as VerticalPromo,
  VerticalPromo as VerticalPromoClass
};
